import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const HeroArea = () => {
  return (
    <div>
      <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
        <div style={{ height: '400px' }}>
          <img
            src="/images/car1.jpg"
            alt="car "
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div style={{ height: '400px' }}>
          <img
            src="/images/car4.jpg"
            alt="car "
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div style={{ height: '400px' }}>
          <img
            src="/images/car5.jpg"
            alt="car "
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div style={{ height: '400px' }}>
          <img
            src="/images/car4.jpeg"
            alt="car "
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
      </Carousel>
    </div>
  );
};

export default HeroArea;
